import { Component, ChangeDetectionStrategy } from '@angular/core';
import { RouterOutlet } from '@angular/router';

@Component({
    selector: 'app-auth-layout',
    imports: [RouterOutlet],
    template: `
    <div class="min-h-screen flex items-center justify-center">
      <router-outlet></router-outlet>
    </div>
  `,
    changeDetection: ChangeDetectionStrategy.Eager,
    styles: ``
})
export class AuthLayoutComponent {} 